import { shouldExcludePath } from './shouldExcludePath';

const SEMVER_RE = /^\d+\.\d+\.\d+$/;
const BUNDLE_FILE_RE = /^cmp\.\d+\.\d+\.\d+\.[0-9a-f]{8}\.iife\.js$/;

let injected = false;

export async function loadCMP(): Promise<void> {
  if (injected) return;
  if (
    typeof window !== 'undefined' &&
    shouldExcludePath(window.location.pathname, window.__cmpConfig?.excludedPaths)
  ) {
    console.info(
      '[CMP loader] current path is excluded via __cmpConfig.excludedPaths — skipping load.',
    );
    return;
  }
  const baseUrl = resolveBaseUrl();
  if (!baseUrl) {
    console.error('[CMP loader] Unable to resolve base URL — document.currentScript is null');
    return;
  }
  let bundleFile: string;
  try {
    const response = await fetch(`${baseUrl}version.json?${Math.random()}`, { cache: 'no-store' });
    if (!response.ok) {
      console.error(`[CMP loader] version.json fetch failed: HTTP ${response.status}`);
      return;
    }
    const payload = await response.json();
    const resolved = resolveBundleFile(payload);
    if (!resolved) {
      console.error('[CMP loader] version.json is malformed:', payload);
      return;
    }
    bundleFile = resolved;
  } catch (err) {
    console.error('[CMP loader] version.json fetch threw:', err);
    return;
  }
  const script = document.createElement('script');
  script.src = `${baseUrl}${bundleFile}`;
  script.defer = true;
  document.head.appendChild(script);
  injected = true;
}

function resolveBaseUrl(): string | null {
  const current = document.currentScript as HTMLScriptElement | null;
  if (!current || !current.src) return null;
  const slash = current.src.lastIndexOf('/');
  return slash >= 0 ? current.src.slice(0, slash + 1) : null;
}

function resolveBundleFile(payload: { version?: unknown; file?: unknown } | null): string | null {
  if (payload?.file !== undefined) return isValidBundleFile(payload.file) ? payload.file : null;
  // `version` alone comes from an artifact built before hashed names, e.g. after a rollback.
  return isValidVersion(payload?.version) ? `cmp.${payload.version}.iife.js` : null;
}

function isValidBundleFile(v: unknown): v is string {
  return typeof v === 'string' && BUNDLE_FILE_RE.test(v);
}

function isValidVersion(v: unknown): v is string {
  return typeof v === 'string' && SEMVER_RE.test(v);
}

if (typeof document !== 'undefined' && document.currentScript) {
  loadCMP();
}
